import { AiTextTool } from 'strapi/component/aiTextTool';
import { BenefitsRow } from 'strapi/component/benefitsRow';
import { BottomBanner } from 'strapi/component/bottomBanner';
import { BreadCrumb } from 'strapi/component/breadcrumb';
import { BulkText } from 'strapi/component/bulkText';
import { Carousel } from 'strapi/component/carousel';
import { CategoryList } from 'strapi/component/categoryList';
import { FrequentlyAskedQuestions } from 'strapi/component/frequentlyAskedQuestions';
import { HeaderBanner } from 'strapi/component/headerBanner';
import { HeroSection } from 'strapi/component/heroSection';
import { ImageText } from 'strapi/component/imageText';
import { MediaSpotlight } from 'strapi/component/mediaSpotlight';
import { MockupsGroup } from 'strapi/component/mockupsGroup';
import { RelatedLinks } from 'strapi/component/relatedLinks';
import SeoCard from 'strapi/component/seo/SeoCard';
import { Steps } from 'strapi/component/steps';
import { TemplateFeed } from 'strapi/component/templateFeed';
import { Testimonial } from 'strapi/component/testimonial';

export enum ComponentType {
  BottomBanner = 'BottomBanner',
  Breadcrumb = 'Breadcrumb',
  Carousel = 'Carousel',
  CategoryList = 'CategoryList',
  ChildrenList = 'ChildrenList',
  FrequentlyAskedQuestions = 'FrequentlyAskedQuestions',
  HeroSection = 'HeroSection',
  ImageSection = 'ImageSection',
  RelatedLinks = 'RelatedLinks',
  Seo = 'Seo',
  Steps = 'Steps',
  TemplateFeed = 'TemplateFeed',
  Testimonial = 'Testimonial',
  TextImageText = 'TextImageText',
  HeaderBanner = 'HeaderBanner',
  MockupsGroup = 'MockupsGroup',
  Claims = 'Claims',
  ImageSectionSingle = 'ImageSectionSingle',
  AiTextTool = 'AiTextTool',
}

export enum ReactComponentType {
  BottomBanner = 'BottomBanner',
  Breadcrumb = 'Breadcrumb',
  Carousel = 'Carousel',
  CategoryList = 'CategoryList',
  FrequentlyAskedQuestions = 'FrequentlyAskedQuestions',
  HeroSection = 'HeroSection',
  ImageSection = 'ImageSection',
  RelatedLinks = 'RelatedLinks',
  SeoCard = 'SeoCard',
  Steps = 'Steps',
  TemplateFeed = 'TemplateFeed',
  Testimonial = 'Testimonial',
  TextImageText = 'TextImageText',
  HeaderBanner = 'HeaderBanner',
  MockupsGroup = 'MockupsGroup',
  Claims = 'Claims',
  MediaSpotlight = 'MediaSpotlight',
  AiTextTool = 'AiTextTool',
}

export type ReactComponents =
  | typeof BottomBanner
  | typeof BreadCrumb
  | typeof Carousel
  | typeof CategoryList
  | typeof FrequentlyAskedQuestions
  | typeof HeroSection
  | typeof ImageText
  | typeof RelatedLinks
  | typeof SeoCard
  | typeof Steps
  | typeof TemplateFeed
  | typeof Testimonial
  | typeof BulkText
  | typeof HeaderBanner
  | typeof MockupsGroup
  | typeof BenefitsRow
  | typeof MediaSpotlight
  | typeof AiTextTool;

export type FixedLengthArray<
  T,
  N extends number,
  R extends readonly T[] = [],
> = R['length'] extends N ? R : FixedLengthArray<T, N, readonly [T, ...R]>;

export type TextAlign = 'left' | 'center';
